import $ from "jquery";

export default {
    name: "ajout-entres",
    components: {},
    props: [],
    data() {
        return {
          loading: false,
          filtered_articles: [],
          entres: [],
          value: "",
          is_empty: false,
        };
    },
    computed: {
        //Old function
        article() {
            return this.$store.getters["all_articles"];
        },

        //New function
        liste_all_articles() {
            return this.$store.getters["liste_all_articles"];
        },

        fournisseurs() {
            return this.$store.getters["fournisseurs"];
        },
    },

    mounted() {
        this.$store.dispatch("getAllListesArticles")

        this.$store.dispatch("getFournisseurs");

        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);
    },

    methods: {
        /**
         * @deprecated
         */
        filterArticle() {
            this.filtered_articles = [];

            if (this.value.length > 1) {
                this.liste_all_articles.forEach((article) => {
                    if (
                        article.article_nom.toLowerCase().includes(this.value.toLowerCase())
                    ) {
                        this.filtered_articles.push(article);
                    }
                });
            }

            this.is_empty = false;
        },

        choiceArticle(article) {
            this.entres.push({
                article: article.article_id,
                libelle: article.article_nom,
                fournisseur: null,
                nombre: null,
                stock: 1,
                peremption: null,
            });
            this.value = "";
            this.filtered_articles = [];
        },

        deleteEntre(index) {
            this.entres.splice(index, 1);
        },

        async submitForm() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            if (this.entres.length == 0) {
              this.is_empty = true;
              return;
            }
            
            
                this.loading = true;

                const data = {
                    articles: this.entres,
                };

                await this.$store.dispatch("saveEntre", data).then((response) => {
                    if (response) {
                        this.loading = false;
                        this.$router.push({ path: "/entres" });
                    } 
                        this.loading = true;
                    
                });
            
        },
    },
};
